"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LogoSlider = require("./LogoSlider");
var _Main = require("./Main");
var _Newsletter = require("./Newsletter");
var _Sub = require("./Sub");
require("./Footer.scss");
const Footer = _ref => {
  let {
    className,
    renderNewsletterForm,
    bar = {
      links: null,
      social: {
        facebook: null,
        linkedin: null,
        twitter: null,
        youtube: null
      }
    },
    contact = null,
    hasNewsletterDisplayed = false,
    sections = [],
    text = {
      copyright: '\xA9 All rights reserved.',
      newsletterTitle: 'Email Newsletter!',
      newsletterText: 'Subscribe now and receive weekly emails with exciting offers, latest news and updates.'
    },
    logos = {
      title: '',
      items: []
    }
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Footer', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_Newsletter.Newsletter, {
    hasNewsletterDisplayed: hasNewsletterDisplayed,
    renderNewsletterForm: renderNewsletterForm,
    text: text
  }), /*#__PURE__*/_react.default.createElement(_Main.Main, {
    contact: contact,
    sections: sections
  }), /*#__PURE__*/_react.default.createElement(_LogoSlider.LogoSlider, {
    title: logos.title,
    items: logos.items
  }), /*#__PURE__*/_react.default.createElement(_Sub.Sub, {
    bar: bar,
    text: text
  }));
};
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map